export default __webpack_public_path__ + "static/media/blog2.d7af1325.jpg";